module.exports = __webpack_public_path__ + "static/media/1.Electric Needle Vibrator.328b7829.jpg";